<template>
<div class="not-found">
  <div class="mx-auto text-center">
    <h3>404 Not Found :(</h3>
    <p>The page you requested was not found</p>
    <router-link to="/" class="btn btn-primary">Go home</router-link>
  </div>
</div>
</template>